import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .warning-text {
    font-size: 18px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    span {
      margin-right: 5px;
      &.text-highlighter {
        font-weight: bold;
      }
    }
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  max-width:${props => props.width || '400px'};  
  .ant-input {
    margin-bottom: 12px;
    color: #555555;
    font-size: 16px;
    font-weight: 600;
  }
  .ant-input-suffix {
    top: 21px !important;
  }
  .ant-input:placeholder-shown {
    font-size: 14px;
    font-weight: normal;
  }
  .ant-input:hover,.ant-input:focus {
    border-color: #b9b8b8 !important;
    border-right-width: 1px !important;
    box-shadow:none !important;
  }
  .note {
    font-size: 14px;
    text-transform: initial;
    font-weight: 400;
    color: rgb(151, 150, 150);
    width: 100%;
    text-align: center;
    padding-top: 25px;
    padding-bottom: 35px;
  }
  .info-message{
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const InputLabel = styled.div`
  color: rgb(49 70 89 / 0.9);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
`;

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 10px;
  &.extra-bottom-space {
    margin-bottom: 20px;
  }
  .ant-select {
    width: 100% !important;
    margin-bottom: 12px;
  }
  .ant-select-selection {
    height: 40px;
    .ant-select-selection__rendered {
      height: 100%;
      display: flex;
      align-items: center;
      .ant-select-selection__choice {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
      }
    }
    .ant-select-selection-selected-value {
      font-size: 16px;
      font-weight: 600;
    }
  }
  &.flex-container {
    display: flex;
    align-items: center;
  }
  &.flex-container.space-between {
    justify-content: space-between;

    > ${InputLabel} {
      margin-bottom: 0;
    }

    > button {
      margin-right: 40%;
    }
  }
  &.ai_container {
    display: flex !important;
    transition: height 2s ease-out; */
  }
  &.ai_textArea {
    flex-direction: column;
    height: ${props => props.isAIText ? '120px' : '0'};
    display: ${props => props.isAIText ? 'flex !important' : 'none !important'}; ;
    transition: height 2s ease-out;
  }
  &:last-child {
    width: ${props => (props.tagInput ? '60%' : '')};
  }
  .ant-btn,.ant-btn[disabled] {
    color: #fff !important;
    background: #000 !important;
    border-color: #000;
    width: 45%;
    height: 40px;
    border-radius:20px;
    text-transform: uppercase;
    font-size: 12px;
  }
  .form_btn {
    text-align: center;
    margin: 20px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
`;

export const PopupContainer = styled.div`
  min-width: 240px;
  max-width: 250px;
  padding: 15px;
  position: relative;
  .ant-input {
    margin-bottom: 12px;
    color: #555555;
    font-size: 14px;
    font-weight: 600;
  }
  .ant-input:placeholder-shown {
    font-size: 12px;
    font-weight: normal;
  }
`;

export const PopupActionContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const PopupLabel = styled.div`
  color: rgb(49 70 89 / 0.9);
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
  width: ${props => props.fillable && '100px'};
`;

export const SaveButton = styled(Button)`
  font-size: 12px;
  height: 30px;
  padding: 8px 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background: ${props => props.fillable ? '#000' : '#df4c35'};
  border-radius:  ${props => props.fillable ? '25px' : '4px'};
  color: #ffffff;
  border: 2px solid transparent;
  &:hover,
  &:focus {
    background: ${props => props.fillable ? '#000' : '#df4c35'};
    color: #ffffff;
    border-color: transparent;
    box-shadow: initial;
  }
`;

export const CancelButton = styled(Button)`
  font-size: 12px;
  height: 30px;
  padding: 8px 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background: ${props => props.fillable ? '#000' : '#ffffff'};
  border-radius:  ${props => props.fillable ? '25px' : '4px'};
  color: ${props => props.fillable ? '#fff' : '#555555'};
  border: 1px solid #b1afaf;
  margin-right: 10px;
  &:hover,
  &:focus {
    background: ${props => props.fillable ? '#000' : '#ffffff'};
    color: ${props => props.fillable ? '#fff' : '#555555'};
    border: 1px solid #b1afaf;
    box-shadow: initial;
  }
`;

export const WarningLabel = styled.div`
  color: #f5222d;
`;

export const AssetAction = styled.div`
 display: flex;
 gap: 20px;
 margin-bottom: 30px;
 align-items: center;

 .desc{
 font-weight:bold
 }
`;
